import Cookies from 'js-cookie';

export const getCookieValue = (cookieName: string): string | undefined =>
  Cookies.get(cookieName) || '';

export const getCookiesValues = (cookieName: string): string[] | undefined => {
  const value = Cookies.get(cookieName);
  return value ? value.split(',') : undefined;
};
